<template>
  <b-row>
    <b-col lg="12">
      <b-card header="Nuevo traslado de vacío">
        <Form :void="this.void" />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Form from './Form'
export default {
  components: { Form },
  data(){
    return{
      void: this.$route.params.void
    }
  }

}
</script>
